import { useI18nText } from '@/lib/utils/i18nText';
import Tooltip from '@/components/Tooltip';
import { getChannelTypeMetricIcon } from '@/lib/utils/channelPlatformMeta';
import { EmptyDash } from '../../utils';
import type { Influencer } from '../../types';

/** Engagement 셀 (원본 Engagement) - Viewers/Subs %, 좋아요 %, 댓글 % 3가지 */
export function EngagementCell({ user, showEmptyDash = true }: { user: Influencer; showEmptyDash?: boolean }) {
  const { t } = useI18nText();
  const chType = user.channels?.[0]?.type ?? 'youtube';
  const vs = user.averageStats?.last5 ?? user.stats?.last5;
  if (!vs) return showEmptyDash ? <EmptyDash /> : null;
  const views = vs.views ?? (vs as { videos?: { views?: number } })?.videos?.views ?? 0;
  const likes = vs.likes ?? (vs as { videos?: { likes?: number } })?.videos?.likes ?? 0;
  const comments = vs.comments ?? (vs as { videos?: { comments?: number } })?.videos?.comments ?? 0;
  const subs = user.stats?.allTime?.subscribers ?? 1;
  const pctVsSubs = views && subs ? ((views * 100) / subs).toFixed(1) : '0';
  const pctLiked = views ? ((likes * 100) / views).toFixed(1) : '0';
  const pctCommented = views ? ((comments * 100) / views).toFixed(1) : '0';
  const rows: { key: string; icon: string; label: string; value: string }[] = [
    { key: 'subs', icon: 'user-o', label: t('Views/subs', '조회/구독'), value: pctVsSubs },
    { key: 'likes', icon: getChannelTypeMetricIcon(chType, 'likes'), label: t('Likes/views', '좋아요/조회'), value: pctLiked },
    { key: 'comments', icon: getChannelTypeMetricIcon(chType, 'comments'), label: t('Comments/views', '댓글/조회'), value: pctCommented },
  ];
  return (
    <div className="eng5-cell">
      {rows.map((r) => (
        <div key={r.key} className="eng5-row">
          <Tooltip content={r.label}>
            <span className="eng5-icon" aria-hidden>
              <i className={`fa fa-${r.icon}`} />
            </span>
          </Tooltip>
          <div className="eng5-content">
            <span className="eng5-label">{r.label}</span>
            <span className="eng5-value">{r.value}%</span>
          </div>
        </div>
      ))}
    </div>
  );
}
